import { render, staticRenderFns } from "./LocationSearch.vue?vue&type=template&id=c54dc254&scoped=true"
import script from "./LocationSearch.vue?vue&type=script&lang=js"
export * from "./LocationSearch.vue?vue&type=script&lang=js"
import style0 from "./LocationSearch.vue?vue&type=style&index=0&id=c54dc254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54dc254",
  null
  
)

export default component.exports